// extracted by mini-css-extract-plugin
module.exports = {"imgWraper":"PercentileChart_imgWraper__gn949","imgHeader":"PercentileChart_imgHeader__1e0WY","image":"PercentileChart_image__qsBYq","imgTitle":"PercentileChart_imgTitle__2SwPe"};